import { useIsFocused } from "@react-navigation/native";
import { useCallback, useContext, useEffect, useState } from "react";
import { RefreshControl, ScrollView, View } from "react-native";
import * as Colors from "../../styles/colors";
import Icon from "react-native-vector-icons/MaterialCommunityIcons";

import PageTitle from "../../components/PageTitle";
import { GlobalContext } from "../../contexts/global";
import { dateFormatBR } from "../../helpers/util";
import { GetWallet } from "../../services/Api/wallet";
import { RemoveSharedWallet } from "../../services/Api/walletShared";
import ButtonWallet from "./components/ButtonWallet";
import WalletCredit from "./components/WalletCredit";

export default function Wallet({ navigation, route }) {
  const { setLoading, setShowAlert, showAlert } = useContext(GlobalContext);
  const [refreshing, setRefreshing] = useState(false);

  const onRefresh = useCallback(() => {
    setRefreshing(true);
    setLoading({ show: "true", message: "Carregando carteira" });
    updateList();
    setRefreshing(false);
  }, []);

  useEffect(
    () =>
      setLoading({
        show: true,
        message: "Carregando carteira",
      }),
    []
  );
  const [wallet, setWallet] = useState(0);

  const isFocused = useIsFocused();

  useEffect(() => {
    if (isFocused) {
      updateList();
    }
  }, [isFocused]);

  const updateList = () => {
    GetWallet()
      .then((value) => {
        setWallet(value.data);
      })
      .catch((error) => {
        setShowAlert({
          type: "alert",
          title: "Oops",
          message:
            error ?? error.erro ?? error.message ?? "Erro ao tentar carregar a carteira",
          show: true,
          confirmText: "OK",
          pressCancel: () => {},
          pressConfirm: () => {
            setShowAlert({ ...showAlert, show: false });
          },
          showConfirmButton: true,
        });
      })
      .finally(() => {
        setLoading({ show: false, message: "" });
      });
  };

  const removeSharedWalletHandler = (username, idWalletShared) => {
    setShowAlert({
      type: "warning",
      title: "Atenção",
      message: `Deseja remover a carteira compartilhada de ${username}?`,
      show: true,
      confirmText: "Sim",
      cancelText: "Não",
      pressCancel: () => {
        setShowAlert({ ...showAlert, show: false });
      },
      pressConfirm: () => {
        removeSharedWallet(idWalletShared);
        setShowAlert({ ...showAlert, show: false });
        setLoading({ show: true, message: "Removendo carteira compartilhada" });
      },
      showConfirmButton: true,
    });
  };

  const removeSharedWallet = (idWalletShared) => {
    RemoveSharedWallet(idWalletShared)
      .then((value) => {
        setShowAlert({
          type: "success",
          title: "Sucesso",
          message: value.message ?? "Carteira compartilhada removida",
          show: true,
          confirmText: "OK",
          pressConfirm: () => {
            setShowAlert({ ...showAlert, show: false });
          },
          showConfirmButton: true,
        });
      })
      .catch((error) => {
        setShowAlert({
          type: "alert",
          title: "Ooops",
          message: error.erro
            ? erro.message
            : "Não foi possível retirar a carteira compartilhada",
          show: true,
          confirmText: "OK",
          pressConfirm: () => {
            setShowAlert({ ...showAlert, show: false });
          },
          showConfirmButton: true,
        });
      })
      .finally(() => {
        updateList();
        setLoading({ show: false, message: "" });
      });
  };

  const infoShared = (userName, emailUser, sharedDate) => {
    setShowAlert({
      type: "info",
      title: "Compartilhado por",
      message: `Nome: ${userName}\nEmail: ${emailUser}\nEm ${dateFormatBR(
        sharedDate
      )}`,
      show: true,
      confirmText: "OK",
      pressConfirm: () => {
        setShowAlert({ ...showAlert, show: false });
      },
      showConfirmButton: true,
    });
  };

  return (
    <PageTitle title={"CARTEIRA"}>
      <ScrollView
        refreshControl={
          <RefreshControl
            refreshing={refreshing}
            onRefresh={onRefresh}
            colors={[Colors.PRIMARY, Colors.SECONDARY]}
          />
        }
      >
        {wallet ? (
          <WalletCredit
            credit={wallet.value}
            walletShared={wallet.walletSharedResponse}
            onPressDelete={() =>
              removeSharedWalletHandler(
                wallet.walletSharedResponse.nameUser,
                wallet.walletSharedResponse.id
              )
            }
            onPressInfo={() =>
              infoShared(
                wallet.walletSharedResponse.nameUser,
                wallet.walletSharedResponse.emailUser,
                wallet.walletSharedResponse.sharedDate
              )
            }
          />
        ) : null}
        <View
          style={{
            flexDirection: "row",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <ButtonWallet
            iconName={"wallet-plus-outline"}
            backgroundColor={Colors.SUCCESS}
            onPress={() => navigation.navigate("CoinPrice")}
            text={"Adicionar crédito"}
            size={"48%"}
          />
          <ButtonWallet
            iconName={"swap-horizontal"}
            backgroundColor={Colors.INFO}
            onPress={() =>
              navigation.navigate("WalletTransfer", { wallet: wallet })
            }
            text={"Transferir crédito"}
            size={"48%"}
          />
        </View>
        <View
          style={{
            flexDirection: "row",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <ButtonWallet
            iconName={"share-variant-outline"}
            backgroundColor={Colors.WARNING}
            onPress={() =>
              navigation.navigate("WalletShared", { idWallet: wallet.id })
            }
            text={"Compartilhar crédito"}
            size={"48%"}
          />
          <ButtonWallet
            iconName={"pie-chart"}
            backgroundColor={Colors.WALLET}
            onPress={() =>
              navigation.navigate("WalletFractionList", { idWallet: wallet.id })
            }
            text={"Fracionar crédito"}
            size={"48%"}
            iconType={"feather"}
          />
        </View>
        <ButtonWallet
          iconName={"credit-card-multiple-outline"}
          backgroundColor={Colors.ALERT}
          onPress={() =>
            navigation.navigate("CreditCardList", { idWallet: wallet.id })
          }
          text={"Cartões"}
          size={"98%"}
        />
      </ScrollView>
    </PageTitle>
  );
}
